import { useLayoutEffect, useSyncExternalStore } from 'react'

// Whether the page shown must keep the address it loaded at, as a failed sign-in's page must: moving
// it to the site's primary address loads it afresh and loses what it shows. Held by what is
// mounted, so the hold ends when the person leaves that page.
let holds = 0
const listeners = new Set<() => void>()

function notify() {
  for (const listener of listeners) {
    listener()
  }
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** True while a page holds its address. */
export function isAddressHeld(): boolean {
  return holds > 0
}

/** Holds the page's address while mounted. A layout effect, so it is in place before the site's lookup answers. */
export function useHoldAddress(): void {
  useLayoutEffect(() => {
    holds += 1
    notify()
    return () => {
      holds -= 1
      notify()
    }
  }, [])
}

/** {@link isAddressHeld}, rendering again when it changes. */
export function useAddressHeld(): boolean {
  return useSyncExternalStore(subscribe, isAddressHeld)
}
